export const FETCH_ADMIN_MASS_NOTIFICATION_LIST =
  'FETCH_ADMIN_MASS_NOTIFICATION_LIST';
export const SET_ADMIN_MASS_NOTIFICATION_LIST =
  'SET_ADMIN_MASS_NOTIFICATION_LIST';
export const FETCH_ADMIN_MASS_NOTIFICATION_DETAILS =
  'FETCH_ADMIN_MASS_NOTIFICATION_DETAILS';
export const SET_ADMIN_MASS_NOTIFICATION_DETAILS =
  'SET_ADMIN_MASS_NOTIFICATION_DETAILS';
export const DROP_ADMIN_MASS_NOTIFICATION = 'DROP_ADMIN_MASS_NOTIFICATION';
